import { createDuck } from 'helpers/duckTools';

export const REDUCER_KEY = 'fuzzySearch';

export const fuzzySearchDuck = createDuck('FUZZY_SEARCH', {
  result: {},
  error: null,
  isLoading: false,
  isLoaded: false,
});

export const reducer = fuzzySearchDuck;
